import React from 'react';
import { Icon, IconProps } from './Icon';

export const DeliveryIcon: React.FC<IconProps> = (props) => {
  const color = props.color || props.fill || 'black';

  return (
    <Icon width="24" height="24" viewBox="0 0 1200 1200" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g fill="none" stroke={color} strokeMiterlimit="10">
        <path
          d="m280.9 838.91c-49.71 0-90-40.29-90-90v-420.55c0-29.02 23.53-52.55 52.55-52.55h436.28c33.5 0 65.99 11.43 92.11 32.41l254.37 247.95c16.17 15.76 25.29 36.16 25.29 73.8v97.08c0 71.56-40.29 111.86-90 111.86"
          strokeWidth="48.08"
        />
        <path d="m720.4 838.91h-205.93" strokeWidth="48.08" />
        <circle cx="402.1" cy="839.94" r="112.38" strokeWidth="50" />
        <circle cx="832.77" cy="839.94" r="112.38" strokeWidth="50" />
        <g strokeWidth="48.08">
          <path d="m551.98 265.36v329.04" />
          <path d="m1049.34 578.03h-858.02" />
        </g>
      </g>
    </Icon>
  );
};
